import React from 'react';
import { useCompleteStripeCheckoutMutation } from '../Api/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import FullPageSpinner from '../Components/Spinner/FullPageSpinner';
import { useLocalization } from '../Components/Helpers/useLocalization';

const OrderProcessingPage: React.FC = () => {
    const location = useLocation();
    const L = useLocalization();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('orderId');
    const [completeOrder] = useCompleteStripeCheckoutMutation();
    const navigate = useNavigate();

    const hasRun = React.useRef(false);

    React.useEffect(() => {
        if (!orderId || hasRun.current) return;
        hasRun.current = true;

        completeOrder({ orderId }).then((result) => {
            if (result.data?.success) {
                navigate('/order-complete');
            }
        });
    }, [orderId]); // eslint-disable-line react-hooks/exhaustive-deps

    return <FullPageSpinner message={L('localization_order_processing')} />;
}

export default OrderProcessingPage;